import React, { createContext, useEffect } from "react";

import { Route, Routes, useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";

import Inventory from "../Inventory";
import Messages from "../Messages";
import Profile from "../Profile";
import SalesRequests from "../SalesRequests";
import SingleSaleRequest from "../SingleSaleRequest";
import SingleVehicle from "../SingleVehicle";
import Team from "../Team";

import { Endpoints } from "../../lib/Endpoints";
import { NonPaginatedResponse } from "../../lib/Responses";
import { AdminProfileProps } from "../../lib/Types";
import { AppContextProps } from "../../lib/context/AppContext";
import { usePerformRequest } from "../../lib/usePerformRequest";

import "./styles.scss";
import Overview from "../Overview";

export const AppContext = createContext<AppContextProps>(undefined);

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const {
    data: profile,
    status,
    reloadData: reloadProfile,
    isLoading: isProfileLoading,
  } = usePerformRequest<NonPaginatedResponse<AdminProfileProps>>({
    method: "GET",
    route: Endpoints.GetAdminProfile(),
  });

  const logoutAdmin = () => {
    localStorage.removeItem("t");
    navigate("/login");
  };
  useEffect(() => {
    if (!isProfileLoading) {
      if (status === 401) {
        logoutAdmin();
      }
    }
  }, [profile, isProfileLoading]);

  return (
    <AppContext.Provider
      value={{
        profile: profile?.data,
        isProfileLoading: isProfileLoading,
        reloadProfile: reloadProfile,
        logoutAdmin: logoutAdmin,
      }}
    >
      <Navbar />
      <Routes>
        <Route index path="/" element={<Overview />} />
        <Route index path="/inventory" element={<Inventory />} />
        <Route index path="/inventory/:vehicleID" element={<SingleVehicle />} />
        <Route index path="/requests" element={<SalesRequests />} />
        <Route index path="/request/:requestID" element={<SingleSaleRequest />} />
        <Route index path="/team" element={<Team />} />
        <Route index path="/profile" element={<Profile />} />
        <Route index path="/messages" element={<Messages />} />
      </Routes>
    </AppContext.Provider>
  );
};

export default Dashboard;
